<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm"></Toolbar>
    <PartyForm ref="createForm" :values="item" :errors="violations"/>
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import PartyForm from '../../components/party/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'Party';

const { mapFields } = createHelpers({
  getterType: 'party/getField',
  mutationType: 'party/updateField'
});

export default {
  name: 'PartyCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    PartyForm
  },
  data() {
    return {
      item: {
          sepaInfo: {
              name: '',
              IBAN: '',
              BIC: ''
          }
      },
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('party', ['create', 'reset']),
    resetForm() {
      this.item = {
        sepaInfo: {
          name: '',
          IBAN: '',
          BIC: ''
        }
      };
    }
  }
};
</script>
